import { render, staticRenderFns } from "./publishForm.vue?vue&type=template&id=4ddb01da&scoped=true"
import script from "./publishForm.vue?vue&type=script&lang=js"
export * from "./publishForm.vue?vue&type=script&lang=js"
import style0 from "./publishForm.vue?vue&type=style&index=0&id=4ddb01da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ddb01da",
  null
  
)

export default component.exports